
export const WeaponStories = () => {
 return (
  <>
   WeaponStories
  </>
 )
}